<template>
    <div class="center-grad">
        <div class="top-head">
            <img src="../../assets/imgs/center/grad-1.jpg" style="width: 100%;" />
            <div class="head-box ">
                <div>
                    <div class="box">
                        <p> A culture</p>
                        <p> of innovation</p>
                        <p> at teaching </p>
                        <p> centers</p>
                        <p style="margin-top: 30%;">不断求新的环境</p>
                     </div>
                </div>
            </div>
        </div>
        <div class="section-content">
            <img src="../../assets/imgs/center/grad-7.png" />
            <div class="adivder"></div>
            <img src="../../assets/imgs/center/grad-8.png" />
            <div class="adivder"></div>
            <img src="../../assets/imgs/center/grad-9.png" />
            <div class="adivder"></div>
            <img src="../../assets/imgs/center/grad-10.png" />
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return{

            }
        },
    }
</script>
<style lang="less">
    .center-grad{
        .top-head{
            position: relative;
            .head-box{
                position: absolute;
                top: 0%;
                left: 50%;
                transform: translateX(-50%);
                width: 1190px;
                height: 100%;
                &>div{
                    font-weight: 600;
                    color: #ffffff;
                    font-size: 42px;
                    width: 450px;
                    height: 100%;
                    background: rgba(251, 195, 0, 0.7);
                    /*opacity: 0.6;*/
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .box {
                        width: 320px;
                        height: 80%;
                        p {
                            line-height: 52px;
                        }
                    }
                }
            }
        }

        .section-content{
            padding: 70px 0px 100px;
            img{
                width: 100%;
            }
            .adivder{
                margin: 80px 0px 60px;
                height: 0px;
                width: 100%;
                border-top: 1px solid #7d7d7d;
            }
        }
    }
</style>
